import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
const events = [{
  id: 1,
  date: 'EVERY TUE',
  day: 'TUESDAY',
  title: 'DREAM HOUSE TUESDAYS',
  type: 'BRANDED WEEKLY NIGHT',
  description: 'Experience the ultimate midweek vibe with our signature Dream House series.',
  time: '10:00 PM - 3:00 AM',
  image: 'https://cdn.magicpatterns.com/uploads/at2R9HfHifzkaQFcUBJR5b/SnapInsta.to_660779906_18095297552328170_5827793037302573987_n.jpg'
}, {
  id: 2,
  date: 'EVERY THU',
  day: 'THURSDAY',
  title: 'THURSDAY NIGHT LIFE',
  type: 'LATE NIGHT VIBES',
  description: 'Kick off the weekend early with curated music and premium lounge atmosphere.',
  time: '10:00 PM - 3:00 AM',
  image: 'https://cdn.magicpatterns.com/uploads/6T3H2WZmmtkMUMZCbd7Kxp/SnapInsta.to_681340710_18095297600328170_3727840379771406033_n.jpg'
}, {
  id: 3,
  date: 'EVERY FRI',
  day: 'FRIDAY',
  title: 'THEATRE FRIDAYS',
  type: 'FRIDAYS AFTER DARK',
  description: 'Part of the Theatre of Dreams brand series. Immersive nightlife at its finest.',
  time: '11:00 PM - 3:00 AM',
  image: 'https://cdn.magicpatterns.com/uploads/rJSkXauUYeoLtet5juNndy/SnapInsta.to_681279189_18095297528328170_1432439404206680717_n.jpg'
}, {
  id: 4,
  date: 'EVERY SAT',
  day: 'SATURDAY',
  title: 'THEATRE SATURDAYS',
  type: 'MAIN TICKETED NIGHT',
  description: 'The pinnacle of HOF nightlife. 21+, dress code enforced. Free entry til 11pm w/ RSVP.',
  time: '11:00 PM - 3:00 AM',
  image: 'https://cdn.magicpatterns.com/uploads/rXCwpc2Nx6ZShu23cqZwyk/SnapInsta.to_682057698_18095297465328170_6663686777263624273_n.jpg'
}, {
  id: 5,
  date: 'EVERY SUN',
  day: 'SUNDAY',
  title: 'MELODIES & MIMOSAS',
  type: 'KARAOKE BRUNCH',
  description: 'Karaoke-style brunch with bottomless food and mimosas. Followed by Rum Punch Sundays.',
  time: '11:00 AM - 10:00 PM',
  image: 'https://cdn.magicpatterns.com/uploads/6VYL7C1UR5Mf2BFZpi16Fi/SnapInsta.to_683810361_18095297495328170_5024856363855259451_n.jpg'
}];
export function EventsSection() {
  return <section id="events" className="py-12 md:py-16 bg-[#0B1014] relative" data-id="element-337">
      <div className="container mx-auto px-6" data-id="element-338">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-end mb-12 md:mb-16 text-center md:text-left" data-id="element-339">
          <div className="mb-6 md:mb-0" data-id="element-340">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-2 tracking-wide" data-id="element-341">
              WEEKLY EVENTS
            </h2>
            <p className="text-[#DDA247] text-sm md:text-lg tracking-widest uppercase" data-id="element-342">
              Experience the best in nightlife
            </p>
          </div>
          <Link to="/events" data-id="element-343">
            <Button variant="outline" size="sm" className="md:size-default" data-id="element-344">
              VIEW FULL CALENDAR
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-345">
          {events.map((event, index) => <motion.div key={event.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-[#11161A] border border-white/5 hover:border-[#DDA247]/50 transition-colors duration-300 flex flex-col rounded-2xl md:rounded-3xl overflow-hidden" data-id="element-346">
              <div className="relative h-56 md:h-72 overflow-hidden" data-id="element-347">
                <div className="absolute top-3 left-3 md:top-4 md:left-4 bg-[#DDA247] text-[#0B1014] px-2 py-0.5 md:px-3 md:py-1 font-bold text-[10px] md:text-xs z-20 rounded-full" data-id="element-348">
                  {event.date}
                </div>
                <img src={event.image} alt={event.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-349" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1014] to-transparent opacity-80" data-id="element-350" />
              </div>

              <div className="p-5 md:p-8 flex flex-col flex-1" data-id="element-351">
                <div className="text-[#DDA247] text-[8px] md:text-[10px] font-black tracking-[0.2em] mb-2 md:mb-3 uppercase" data-id="element-352">
                  {event.type}
                </div>
                <h3 className="text-lg md:text-2xl font-bold text-white mb-2 md:mb-3 leading-tight" data-id="element-353">
                  {event.title}
                </h3>
                <p className="text-gray-400 text-xs md:text-sm mb-4 md:mb-6 line-clamp-2 md:line-clamp-3" data-id="element-354">
                  {event.description}
                </p>
                <p className="text-gray-500 text-[8px] md:text-[10px] font-bold uppercase tracking-widest mb-4 md:mb-8 mt-auto" data-id="element-355">
                  {event.day} • {event.time}
                </p>
                <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-356">
                  <Link to="/bottle-service" data-id="element-357">
                    <Button variant="primary" fullWidth size="sm" className="text-[10px] px-2" data-id="element-358">
                      TICKETS
                    </Button>
                  </Link>
                  <Link to="/bottle-service" data-id="element-359">
                    <Button variant="outline" fullWidth size="sm" className="text-[10px] px-2" data-id="element-360">
                      VIP
                    </Button>
                  </Link>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}